// Polyfills must be imported before React
import '@wix/da-react-app/pkg/client/polyfills';

/* eslint-disable @wix/da/import-scss-last */
// project-base needs to go before app styles
import '@wix/da-ds/src/styles/project-base.scss';

import StudioWrapper from './pages/StudioWrapper';
import { setupClient } from './helpers/clientSetup';

setupClient({
  component: StudioWrapper,
  enableHistoryListener: true,
});
